import type { AdCardRendererProps } from "../types";

export default function AdCardDocument({ ad }: AdCardRendererProps) {
    return (
        <div className="adcard-doc">
            <span className="adcard-doc__ico">📄</span>
            <div className="adcard-doc__name">{ad.name || "Untitled document"}</div>
            <div className="adcard-doc__meta">Document</div>
        </div>
    );
}
